import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Buscás guías de TP y todo está desactualizado o no cumple la AEA', 'Explicar cálculo de sección y caída de tensión sin ejercicios prácticos listos', 'Armás tus fichas de taller desde cero cada semana', 'Evaluaciones improvisadas sin criterios claros de corrección', 'No hay conexión entre la teoría del aula y lo que el alumno toca en el tablero', 'Terminás el domingo a las 11 de la noche con el cursor parpadeando en un Word en blanco'];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-160">
      <div className="max-w-3xl mx-auto" data-id="element-161">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-6 text-white leading-tight" data-id="element-162">
          💣 ¿CUÁNTOS DOMINGOS MÁS VAS A PERDER ASÍ?
        </h2>

        <p className="text-sm md:text-base text-gray-400 mb-8 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-163">
          Sos docente en una escuela técnica industrial. Enseñás instalaciones
          eléctricas, electrotecnia o taller…
          <br data-id="element-164" />
          <br data-id="element-165" />
          <span className="text-white font-bold" data-id="element-166">
            Pero nadie te dio un sistema pensado para el taller real.
          </span>
        </p>

        <div className="bg-brand-card border-l-4 border-brand-accent p-5 md:p-6 rounded-r-lg mb-10" data-id="element-167">
          <div className="space-y-3" data-id="element-168">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-169">
                <XCircle className="w-5 h-5 text-red-500 mr-3 shrink-0 mt-0.5" data-id="element-170" />
                <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-171">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-172">
          <p className="text-lg md:text-xl font-bold text-brand-accent mb-2 neon-glow" data-id="element-173">
            👉 No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <div className="text-center" data-id="element-174">
          <h3 className="text-xl md:text-3xl font-black text-white" data-id="element-175">
            💡 ¿Y SI ESTE FUERA EL ÚLTIMO DOMINGO ASÍ?
          </h3>
        </div>
      </div>
    </section>;
}